export class ApiError extends Error {
  constructor(
    public readonly code: string,
    public readonly status: number,
    public readonly body: string = "",
    public readonly raw?: unknown,
  ) {
    super(code);
    this.name = "ApiError";
  }

  is(code: string): boolean {
    return this.code === code;
  }

  isAny(...codes: string[]): boolean {
    return codes.includes(this.code);
  }
}
